/**
 * Data Attributes
 * ===============
 *
 * data-aos-stagger-time
 */

const AOS_PARENT_CLASS = 'aos';
const AOS_CHILD_CLASS = 'aos__child';

const AOS_PARENT_ACTIVE_CLASS = 'aos--active';
const AOS_CHILD_ACTIVE_CLASS = 'aos__child--active';

const AOS_STAGGER_TYPE_INTERVAL_CLASS = 'aos-stagger-type-interval';
const AOS_STAGGER_DISABLE_CLASS = 'aos-stagger-disable';
const AOS_FORCE_ACTIVE_CLASS = 'aos-force-active';
const AOS_FORWARD_ONLY_CLASS = 'aos-forward-only';

const AOS_ACTIVE_EVENT = 'aosactive';
const AOS_INACTIVE_EVENT = 'aosinactive';

const STAGGER_TIME = 200;

class ScrollTrigger {
    constructor() {
        this._aosParentElements = document.querySelectorAll(`.${AOS_PARENT_CLASS}`);

        const options = {
            root: null,
            //threshold: 0.4,
            rootMargin: '100% 0px -10% 0px',
        };
        this._intersectionObserver = new IntersectionObserver((entries) => {
            entries.forEach(this._addAnimationCSS);
        }, options);

        this._run();
    }
    _run = () => {
        this._aosParentElements.forEach((aosParentElement) => {
            if (!aosParentElement.querySelector(`.${AOS_CHILD_CLASS}`)) {
                const aosChildElements = aosParentElement.querySelectorAll(`.${AOS_PARENT_CLASS} > *`);
                aosChildElements.forEach((aosChildElement) => aosChildElement.classList.add(AOS_CHILD_CLASS));
            }

            if (aosParentElement.classList.contains(AOS_FORCE_ACTIVE_CLASS)) {
                this._addAnimationCSS(aosParentElement);
            } else {
                this._intersectionObserver.observe(aosParentElement);
            }
        });
    };

    _getAOSChildElements = (element, parentClass, childClass) => {
        const result = [];

        const traverse = (node) => {
            if (node !== element && node.classList.contains(parentClass)) {
                return;
            }

            if (node.classList.contains(childClass)) {
                result.push(node);
            }

            for (const child of node.children) {
                traverse(child);
            }
        };

        traverse(element);
        return result;
    };
    _resetAnimations(aosChildElements) {
        aosChildElements &&
            aosChildElements.forEach((aosChildElement, index) => {
                const parent = aosChildElement.closest(`.${AOS_PARENT_CLASS}`);
                if (parent && !parent.classList.contains(AOS_FORCE_ACTIVE_CLASS)) {
                    aosChildElement.style.removeProperty('transition-duration');
                }
            });
    }
    _addAnimationCSS = (entry) => {
        const element = entry.target || entry;
        const isElementIntersecting = entry.target ? entry.isIntersecting : true;

        // const aosChildElements = element.querySelectorAll(`.${AOS_PARENT_CLASS} .${AOS_CHILD_CLASS}`);
        // const aosChildElements = element.querySelectorAll(`.${AOS_CHILD_CLASS}`);
        const aosChildElements = this._getAOSChildElements(element, AOS_PARENT_CLASS, AOS_CHILD_CLASS);

        this._resetAnimations(aosChildElements);

        const aosStaggerTime = element.dataset.aosStaggerTime;

        const aosStaggerTypeInterval = element.classList.contains(AOS_STAGGER_TYPE_INTERVAL_CLASS);
        const aosForwardOnly = element.classList.contains(AOS_FORWARD_ONLY_CLASS);

        const aosStaggerDisable = element.classList.contains(AOS_STAGGER_DISABLE_CLASS);
        if (isElementIntersecting) {
            requestAnimationFrame(() => {
                element.classList.add(AOS_PARENT_ACTIVE_CLASS);
            });
            let intersect = new Event(AOS_ACTIVE_EVENT);
            document.dispatchEvent(intersect);

            let timeIncrement = 0;

            aosChildElements &&
                aosChildElements.forEach((aosChildElement, index) => {
                    if (!aosStaggerDisable) {
                        let staggerTime;

                        if (aosStaggerTime) {
                            staggerTime = parseFloat(aosStaggerTime);
                        } else {
                            staggerTime = STAGGER_TIME;
                        }

                        if (aosStaggerTypeInterval) {
                            setTimeout(() => {
                                requestAnimationFrame(() => {
                                    aosChildElement.classList.add(AOS_CHILD_ACTIVE_CLASS);
                                });
                            }, staggerTime * index);
                        } else {
                            if (!aosChildElement.classList.contains(AOS_CHILD_ACTIVE_CLASS)) {
                                const currDuration = parseFloat(getComputedStyle(aosChildElement).transitionDuration) * 1000;
                                const newDuration = currDuration + timeIncrement;

                                aosChildElement.style.setProperty('transition-duration', `${newDuration}ms`, 'important');
                                timeIncrement += staggerTime;

                                requestAnimationFrame(() => {
                                    aosChildElement.classList.add(AOS_CHILD_ACTIVE_CLASS);
                                });
                            }
                        }
                    }
                });
        } else {
            if (!aosForwardOnly) {
                requestAnimationFrame(() => {
                    element.classList.remove(AOS_PARENT_ACTIVE_CLASS);
                });
                let intersect = new Event(AOS_INACTIVE_EVENT);
                document.dispatchEvent(intersect);

                aosChildElements &&
                    aosChildElements.forEach((aosChildElement, index) => {
                        if (!aosStaggerDisable) {
                            aosChildElement.style.removeProperty('transition-duration');

                            requestAnimationFrame(() => {
                                aosChildElement.classList.remove(AOS_CHILD_ACTIVE_CLASS);
                            });
                        }
                    });
            }
        }
    };
}

let scrollTrigger = new ScrollTrigger();
document.addEventListener('wpgbrender', () => {
    setTimeout(() => {
        scrollTrigger = new ScrollTrigger();
    }, 0);
});
